import { Columns3, LayoutGrid, List, Network, Table } from 'lucide-react'

import type { ListViewSwitcherOption } from '@/components/filters/list-view-switcher'

export type MemoriesViewMode = 'list' | 'graph'
export type ApplicantsBoardView = 'kanban' | 'list'

export const ADMIN_USERS_VIEW_OPTIONS = [
  { value: 'cards' as const, label: 'Cards', icon: LayoutGrid },
  { value: 'table' as const, label: 'Table', icon: Table },
] satisfies ListViewSwitcherOption[]

export const MEMORIES_VIEW_OPTIONS = [
  { value: 'list' as const, label: 'List', icon: List },
  { value: 'graph' as const, label: 'Graph', icon: Network },
] satisfies ListViewSwitcherOption<MemoriesViewMode>[]

export const APPLICANTS_BOARD_VIEW_OPTIONS = [
  { value: 'kanban' as const, label: 'Kanban', icon: Columns3 },
  { value: 'list' as const, label: 'List', icon: List },
] satisfies ListViewSwitcherOption<ApplicantsBoardView>[]
